import { getComplaints } from "@/services/disputes.service";
import { useQuery } from "@tanstack/react-query";

export const useComplaints = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "complaints",
    params.page,
    params.size,
    params.disputeType,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getComplaints(params),
    enabled,
    ...options,
  });
};
